import { useState, useContext, useEffect } from 'react';
import { ChevronLeft } from '../../assets/icons'
import { CommentsView } from '.'
import { DocumentsContext, SingleDocumentContext } from '../../context';
import { Help } from '@mui/icons-material';
import { documentCommentSections } from '../../utils';

const PublicDocumentSidebar = () => {
    const { document } = useContext(SingleDocumentContext)
    const { templates } = useContext(DocumentsContext)
    
    const [showCommentsAccordion, setShowCommentsAccordion] = useState(false)

    const [commentsGeneral, setCommentsGeneral] = useState([])
    const [commentSections, setCommentSections] = useState([])

    useEffect(() => {
        if (!document) return
        const commentSections = documentCommentSections(document, templates[document?.template])
        const commentsGeneral = [...(document.commentsGeneral || [])]
        setCommentsGeneral(commentsGeneral)
        setCommentSections(commentSections)
    }, [document, templates])

    return (
        <div
            className={`single-document__left single-document__left--public`}
        >
            <div className='accordion-parent'>
                <div className='accordion-heading accordion-heading--tall flex flex-row justify-between mb-4 gap-2 !align-start'>
                    <Help />
                    <span className='text'>Grâce à un clic long sur les items / le texte du document, vous pouvez proposer une modification ou bien simplement commenter.</span>
                </div>
                <div className={`accordion-heading ${showCommentsAccordion && 'active'}`} onClick={() => setShowCommentsAccordion(!showCommentsAccordion)}>
                    <span>Commentaires</span>
                    <ChevronLeft />
                </div>
                <section className={`${showCommentsAccordion && 'active'} doc-info mb-6`}>
                    <CommentsView comments={commentsGeneral} isGeneralComments={true} />
                    <CommentsView commentSections={commentSections} canAddComment={true} />
                </section>
            </div>
        </div>
    )
}

export default PublicDocumentSidebar
